import { HelpMessage } from 'utils/constants'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import BreakDataTable from '../../../BreakDataTable'
import { ConcreteCoreMeasurement } from '../../types'
import FirstTable from './components/FirstTable'

export function useExpand(): ExpandOptions<ConcreteCoreMeasurement> {
  return {
    render: (record) => ({
      custom: [
        { children: <FirstTable {...record} /> },
        {
          children: (
            <BreakDataTable
              breakData={record.concreteCoreBreakData ?? []}
              help={HelpMessage.Concrete.ConcreteTestSetTracker.BreakData.Core}
              rowKey={() => record.globalId}
            />
          ),
        },
      ],
    }),
  }
}
